/**
 * 竖滑切集的判定。
 *
 * 单独拿出来是因为这是整个交互里最容易调错、又最难靠肉眼验的部分：
 * 阈值大一点就「滑不动」，小一点就「想拖进度条结果跳集了」。
 */

/** 滑过视口高度的这个比例就算切集。 */
const DISTANCE_RATIO = 0.12
/** 快速轻扫：手指走得不远但很快，照样切。短剧的刷法多半是这种。 */
const FLING_SPEED = 0.45 // px/ms
const FLING_MIN_DISTANCE = 24
/** 没到这个位移前不判断方向，避免把点按的微小抖动当成滑动。 */
export const DIRECTION_LOCK_PX = 8

export type SwipeIntent = 'next' | 'prev' | 'stay'

/**
 * dy 是手指相对起点的位移（向上为负）。
 * 向上滑看下一集，和所有短视频流一致。
 */
export function decideSwipe(dy: number, elapsedMs: number, viewportHeight: number): SwipeIntent {
  const distance = Math.abs(dy)
  // 耗时 0 毫秒意味着**快到计时器都没分辨出来**，是最果断的那种甩动，
  // 不是「没动」。写成 0 的话这一甩会被当成慢拖，直接弹回去。
  const speed = elapsedMs > 0 ? distance / elapsedMs : Infinity
  const far = distance >= viewportHeight * DISTANCE_RATIO
  const fling = speed >= FLING_SPEED && distance >= FLING_MIN_DISTANCE
  if (!far && !fling) return 'stay'
  return dy < 0 ? 'next' : 'prev'
}

/**
 * 到头了还在拉的那一段要变「沉」，手感上告诉人没有下一集了。
 * 不拦住的话画面会整屏拉空，露出底下的黑色。
 */
export function rubberBand(dy: number, atFirst: boolean, atLast: boolean): number {
  const pullingPrev = dy > 0 // 向下拉 = 想看上一集
  if ((pullingPrev && atFirst) || (!pullingPrev && atLast)) return dy * 0.28
  return dy
}

/**
 * 竖向手势和「横向拖进度条」要分开。
 * 只看竖直位移的话，拖进度条时手指稍微上飘一点就会跳到下一集。
 */
export function isVertical(dx: number, dy: number): boolean {
  return Math.abs(dy) > Math.abs(dx)
}
